
export const authorizedHeader = () => {
  const authToken = localStorage.getItem("authToken");
  if (authToken) {
    return {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    };
  } else {
    return { "Content-Type": "application/json" };
  }
};